<template>
    <div>
        <h3>Observaciones <Button @click="editarObservacion" icon="fas fa-plus">Guardar</Button></h3>
        <textarea name="observaciones" rows="2" cols="5" v-model="observacion"></textarea>
    </div>
</template>

<script>
    export default {
        props: ['observaciones'],
        data() {
            return {
                observacion: this.observaciones
            }
        },
        methods: {
            editarObservacion() {
                this.$emit('actualizar', this.observacion);
            },
        }
    }
</script>